/* eslint-disable react/style-prop-object */
import { memo } from 'react'
import NextHead from 'next/head'
import getConfig from 'next/config'

export const Head = memo(() => {
  const title = 'Blocket - Sveriges största marknadsplats, bilar, bostäder, möbler m.m.'
  const { publicRuntimeConfig } = getConfig()
  const assetsUrl = publicRuntimeConfig.SHARED_ASSETS_URL

  return (
    <NextHead>
      <title>{title}</title>
      <meta key="og:type" property="og:type" content="website" />
      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:image"
        property="og:image"
        content={`${assetsUrl}/images/blocketLogotype.png`}
      />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon-64.png`} sizes="64x64" />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon-128.png`} sizes="128x128" />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon-196.png`} sizes="196x196" />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon.png`} />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon-16.png`} />
      <link rel="icon" href={`${assetsUrl}/favicon/favicon-32.png`} />
      <link rel="apple-touch-icon" href={`${assetsUrl}/favicon/apple-touch-icon-152.png`} />
    </NextHead>
  )
})

export default Head
